import { useEffect, useRef, useState } from "react";
import { api, errMsg } from "@/lib/api";

export function useApiGet(path, params, deps) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const reqId = useRef(0);
  useEffect(() => {
    const id = ++reqId.current;
    setLoading(true);
    const clean = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v));
    api.get(path, { params: clean })
      .then((r) => { if (id === reqId.current) { setData(r.data); setError(""); } })
      .catch((e) => { if (id === reqId.current) setError(errMsg(e, "Could not load")); })
      .finally(() => { if (id === reqId.current) setLoading(false); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return { data, error, loading };
}
